const WEBSOCKET_SEND_MESSAGE_CONFIGURATION = {
  eventType: '$default',
  service: 'gil-api-mng-amz-ldg',
};

export { WEBSOCKET_SEND_MESSAGE_CONFIGURATION };
